module.exports = __webpack_public_path__ + "img/qianjiangjidi2.c23c6aaf.png";